const phases = [
    { name: "Nueva", style: { border: "1px solid rgba(212,175,55,0.6)", background: "transparent" } },
    { name: "Creciente", style: { boxShadow: "inset 4px 0 0 0 #d4af37", border: "1px solid rgba(212,175,55,0.35)" } },
    { name: "Cuarto", style: { background: "linear-gradient(to right, transparent 50%, #d4af37 50%)", border: "1px solid rgba(212,175,55,0.5)" } },
    { name: "Gibosa", style: { background: "#d4af37", boxShadow: "inset 4px 0 0 0 #0f0d11" } },
    { name: "Llena", style: { background: "radial-gradient(circle, #f6e27a 0%, #d4af37 100%)", boxShadow: "0 0 10px rgba(212,175,55,0.55)" } },
];

export const MoonPhases = ({ size = 14, className = "" }) => (
    <div className={`flex items-center gap-3 ${className}`} aria-hidden="true">
        {phases.map((p) => (
            <span
                key={p.name}
                title={`Luna ${p.name}`}
                className="rounded-full inline-block"
                style={{ width: size, height: size, ...p.style }}
            />
        ))}
    </div>
);
